import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useLang from "../../../hooks/useLang";
const Sliders = () => {
    const navigate = useNavigate();
    const storeFrontData = useSelector((state) => state.app.storeData);
    const banners = storeFrontData.banners;
    const lang = useLang();
    return (
        <div style={{ direction: 'initial' }} className="mt-1">
            <Carousel
                infiniteLoop={true}
                autoPlay={true}
                showThumbs={false}
                showArrows={true}
                showStatus={false}
                renderIndicator={(onClick, isActive, index, label) => {
                    return (
                        <button className={isActive ? "active-slide-indicator" : "slide-indicator"}
                            onClick={onClick}
                        ></button>
                    );
                }}
            >
                {
                    banners.map((item) => {
                        return (
                            <div className="slider-image" key={item.id} >
                                <button
                                    onClick={() => {
                                        navigate('/shop/collection/' + item.collection_id + '/' + (lang === "en" ? item.banner_title : item.banner_title_ar))
                                    }}
                                >
                                    <img src={item.banner_image} alt={item.banner_title} className="lg:h-full h-60" />
                                </button>
                            </div>
                        );
                    })
                }
            </Carousel>
        </div>

    );
}
export default Sliders;